import Vue from "vue";
import VueRouter, { RouteConfig, RawLocation, Route } from "vue-router";
// import Home from "../views/Home.vue";
import HumanCapital from "../views/HumanCapital.vue";

type PushFunction = (location: RawLocation) => Promise<Route>;

const originalPush: PushFunction = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: RawLocation) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

type IconRouteConfig = RouteConfig & {
  hidden?: boolean;
  icon?: string;
  children?: IconRouteConfig[];
};

const routes: Array<IconRouteConfig> = [
  {
    path: "/human_capital",
    name: "人力成本",
    icon: "el-icon-s-order",
    component: HumanCapital,
  },
  {
    path: "*",
    redirect: "/human_capital",
    hidden: true,
  },
  // {
  //   path: "/",
  //   name: "Home",
  //   component: Home,
  // },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
  // {
  //   path: "/level0",
  //   name: "Level0",
  //   children: [
  //     { path: "/level0/0_0_level1", name: "0-0-Level1" },
  //     { path: "/level0/0_1_level1", name: "0-1-Level1" },
  //   ],
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
